(function($) {
	var $ = jQuery = $;

	main.ABProductPage = new function() {
	  var _ = this;

	  _.class = "ABProductPage";

	  //Initialisation
	  _.init = function() {
	  	_.createEventHandlers();
        if($(window).width()<=480) {
          setTimeout(_.pageReadyInit,250);
        }
	  	_.acknowledge("initialisation complete");
	  }

      _.pageReadyInit = function(){
        console.log("pageReadyInit ("+$("#ingredients .ingredients--active .ingredients--block").length+")");
        if(!$("#ingredients h2").is("[data-initialised]")) {
          $("#ingredients h2").addClass("active");
          $("#ingredients h2").attr("data-initialised","true");
        }
        if($("#ingredients .ingredients--active .ingredients--block").length>0) {
          console.log($("#ingredients .ingredients--active .ingredients--block").length);
          $("#ingredients .ingredients--active").addClass("splide");
          $("#ingredients .ingredients--active .ingredients--block").wrapAll("<div class='splide__track'></div>");
          $("#ingredients .ingredients--active .ingredients--block").wrapAll("<div class='splide__list'></div>");
          $("#ingredients .ingredients--active .ingredients--block").addClass("splide__slide");
          var splide = new Splide("#ingredients .splide",{
            type:'slide',
            perPage:1,
          });
          splide.mount();
          $(".page-holder-title h4").eq(0).trigger("click");
        } else {
          setTimeout(_.pageReadyInit,250);
        }
      }

	  _.createEventHandlers = function() {
        $('body').on('click','[data-product-action]',function(e){
          var $element = $(e.currentTarget);
          _.product_action[$element.attr('data-product-action')]($element);
          return false;
        }).on('click','#full-ingredients h2,#ingredients h2,#nutrition h2,#suggested h2,.page-holder-title h4',function(e){
          var $element = $(e.currentTarget);
          _.product_action.expand_section($element);
          return false;
        }).on('click','.product_title',function(e){
          if(!$(e.target).hasClass("product-back")) {
            var $element = $(e.currentTarget);
            if(e.clientX<($(window).width()/2)) {
              window.location.href = "/collections/supplements";
            } else {
              _.product_action.buy_overlay($element);
            }
            return false;
          }
        }).on('click','#mobile-buy-overlay',function(e){
          if(e.target==e.currentTarget){
            var $element = $(e.currentTarget);
            _.product_action.close_overlay($element);
            return false;
          }
        }).on('click','#mobile-menu',function(e){
          var $element = $(e.currentTarget);
          _.product_action.toggle_menu($element);
          return false;
        });
        
	  }
      
      _.product_action = new function() {
        var __ = this;
        __.expand_section = function($element) {
          if($element.closest(".page-holder-title").length==1){
            $element.toggleClass("active");
            $element.closest(".page-holder-title").next(".page-holder").slideToggle(250);
          } else {
            $element.toggleClass("active");
            $element.closest("div").children("*:not(h2,h4)").slideToggle(250);
          }
        }
        __.buy_overlay = function($element) {
          if($("#mobile-buy-overlay").is(":visible")){
            __.close_overlay($element);
          } else {
            $("#mobile-buy-overlay .buy-overlay--contents").empty();
            $("#mobile-buy-overlay .buy-overlay--contents").append($("#pp-product-form").clone());
            $("#mobile-buy-overlay").slideDown(150);
            $element.find("b").attr("data-button-label","CANCEL");
          }
        }
        __.close_overlay = function($element) {
          $("#mobile-buy-overlay").slideUp(150);
          $element.find("b").attr("data-button-label","BUY NOW");
        }
        __.toggle_menu = function($element) {
          $("body").toggleClass("menu-open");
        }
      }

	  //System level operations
	  _.acknowledge = function(message) {
	  	console.log(message + " [from " + _.class + " func]");
	  }
	}

	$(function(){ main.ABProductPage.init(); });

})(main.jQuery);